import { render, staticRenderFns } from "./PostalCodeRegister.vue?vue&type=template&id=457f61d1&"
import script from "./PostalCodeRegister.vue?vue&type=script&lang=js&"
export * from "./PostalCodeRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports